import { render, staticRenderFns } from "./SavedSearchDropDown.vue?vue&type=template&id=ce13f3a8&scoped=true&"
import script from "./SavedSearchDropDown.vue?vue&type=script&lang=js&"
export * from "./SavedSearchDropDown.vue?vue&type=script&lang=js&"
import style0 from "./SavedSearchDropDown.vue?vue&type=style&index=0&id=ce13f3a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce13f3a8",
  null
  
)

export default component.exports